export default {
  colors: {
    text: "#1D1D1B",
    background: "#ffffff",
    primary: "#E54415",
    primaryLightLight: "#f9cec1",
    primaryLight: "#f39a82",
    primaryLightHover: "#f18c70",
    primaryLightLightHover: "#f7c0af",
    secondary: "#1D1D1B",
    light: "#ffffff",
    dark: "#1D1D1B",
    darkGrey: "#5c5a56",
    lightGrey: "#f4f3ee",
  },
  fonts: {
    body:
      'Poppins, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    heading:
      'Roboto Slab, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
  },
  space: [0, 4, 8, 16, 32, 64, 96, 128, 192, 256, 512],
  fontSizes: [13, 15, 16, 20, 24, 32, 48, 64],
  fontWeights: {
    body: 400,
    heading: 700,
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  sizes: {
    container: 1120,
  },
  radii: {
    none: "0",
    sm: ".5rem",
    default: "1rem",
    lg: "2rem",
    full: "9999px",
  },
  shadows: {
    none: "none",
    default:
      "0 13px 27px -5px rgb(50 50 93 / 25%), 0 8px 16px -8px rgb(0 0 0 / 30%), 0 -6px 16px -6px rgb(0 0 0 / 3%)",
  },
  text: {
    heading: {
      fontSize: 7,
      fontFamily: "heading",
      lineHeight: "heading",
      fontWeight: "heading",
      color: "primary",
    },
    display: {
      fontSize: [5, 7],
      fontFamily: "heading",
      lineHeight: "heading",
      fontWeight: "heading",
      textTransform: "uppercase",
    },
    displaySmall: {
      fontSize: [5],
      fontFamily: "heading",
      lineHeight: "heading",
      fontWeight: "heading",
      textTransform: "uppercase",
      color: "dark",
    },
    headingSmall: {
      fontSize: 3,
      fontWeight: "bold",
      color: "primary",
    },
    lead: {
      fontSize: 4,
      color: "dark",
      textTransform: "uppercase",
      fontWeight: "body",
      lineHeight: "heading",
    },
    subtitle: {
      fontSize: 3,
      lineHeight: "body",
      color: "darkGrey",
    },
    label: {
      fontSize: 1,
      textTransform: "uppercase",
      color: "darkGrey",
    },
    caption: {
      fontSize: 0,
    },
  },
  layout: {
    header: {
      maxWidth: ["100%"],
      padding: [2, 4],
    },
    container: {
      padding: [3, 4],
    },
    small: {
      maxWidth: "600px",
    },
    large: {
      maxWidth: "1440px",
      padding: [3, 4],
    },
  },
  buttons: {
    arrowPrev: {
      padding: "15px",
      borderRadius: "0px",
      bg: 'primaryLight',
      "&:hover": {
        bg: "primaryLightHover",
      },
    },
    arrowNext: {
      padding: "15px",
      borderRadius: "0px",
      bg: 'primaryLightLight',
      "&:hover": {
        bg: "primaryLightLightHover",
      },
    },
  },
  links: {
    fontWeight: "body",
    nav: {
      "&.active": {
        color: "dark",
        borderBottom: "1px solid",
        borderColor: "dark",
      },
      fontWeight: "body",
    },
    menu: {
      fontSize: [1],
      color: "dark",
      fontWeight: "bold",
      "&.active": {
        color: "light",
      },
      "&:hover": {
        color: "light",
      },
    },
    darkMenu: {
      fontSize: [1],
      color: "light",
      "&.active": {
        color: "light",
        fontWeight: "bold",
      },
      fontWeight: "body",
    },
    dropdownMenu: {
      fontSize: [1],
      "&.active": {
        color: "dark",
      },
      "&:hover": {
        color: "dark",
      },
      fontWeight: "body",
    },
    sidebar: {
      fontSize: 3,
      fontWeight: "bold",
      "&.active": {
        color: "primary",
      },
      "&:hover": {
        color: "primary",
      },
    },
    sidebarItem: {
      "&.active": {
        color: "primary",
        fontWeight: "heading",
      },
      fontWeight: "body",
    },
    breadcrumbs: {
      color: "text",
      textDecoration: "none",
      "&:hover": {
        color: "light",
      },
    },
  },
  styles: {
    root: {
      fontFamily: "body",
      fontWeight: "body",
      h3: {
        marginTop: 0,
        marginBottom: 1,
      },
      p: {
        marginTop: 0,
      },
      a: {
        color: "primary",
        "&:hover": {
          textDecoration: "none",
        },
      },
      ul: {
        paddingLeft: "20px",
      },
      "--swiper-theme-color": "#E54415",
      ".swiper-container": { pb: 5 },
    },
  },
}
